export default __webpack_public_path__ + "static/media/sports.7a9e1523.png";